export default "__VITE_ASSET__BMAohofT__"